<script>
	import { PUBLIC_APP_NAME } from "$env/static/public";
	import { slide } from "svelte/transition";

	let open = false;
	let links = [
		{
			href: "/",
			text: "Home",
		},
		{
			href: "/locations",
			text: "Locations",
		},
		{
			href: "/collections",
			text: "Collections",
		},
		{
			href: "/plans",
			text: "Plans",
		},
		{
			href: "/login",
			text: "Login",
		},
	];

	function close() {
		open = false;
	}
</script>

<nav class="flex flex-row items-center bg-primary c-on-primary p-4 gap-4">
	<button on:click={() => (open = true)}><div class="i-ph-list-bold text-3xl" /></button>
	<a href="/" class="flex gap-2 text-lg">
		<img src="/apple-touch-icon.png" alt="Logo" class="h-7 w-auto rounded" />
		<span>{PUBLIC_APP_NAME}</span>
	</a>
</nav>

<!-- Slide out -->
{#if open}
	<div
		class="flex flex-col fixed left-0 top-0 h-screen w-70 p-6 pt-[calc(var(--safe-area-top)+1.5rem)] gap-6 z-100 bg-primary c-on-primary shadow-lg shadow-dark"
		transition:slide={{ axis: "x", duration: 180 }}
	>
		<button on:click={close}><div class="i-ph-x text-3xl" /></button>
		{#each links as link}
			<a href={link.href} class="w-full hover:underline flex items-center" on:click={close}>
				<span class="i-ph:dot-outline text-lg" />
				<span>{link.text}</span>
			</a>
		{/each}

		<div class="absolute left-0 bottom-4 w-full text-center">{PUBLIC_APP_NAME}</div>
	</div>

	<!-- Close overlay by tapping outside. 17.5rem = 70 -->
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div class="fixed left-70 top-0 h-screen w-[calc(100vw-17.5rem)] z-99" on:click={close} />
{/if}
